import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { DocumentsMonitoring } from '@/features/documents-monitoring'
import { requireAdmin } from '@/lib/route-guards'

// `?doc=<id>` : ouvre le tiroir de ce document (lien « Ouvrir le document »
// depuis « Tâches & signalements »).
const searchSchema = z.object({
  doc: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/documents/validation')({
  beforeLoad: requireAdmin,
  validateSearch: searchSchema,
  component: DocumentsMonitoring,
})
